import { InferType, object, ObjectSchema, string } from "yup";
import { LoginContract } from "../contracts/login.contracts";

export const loginSchema: ObjectSchema<LoginContract> = object({
    email: string().email("E-mail inválido").required("E-mail é obrigatório"),
    password: string().required("Senha é obrigatório"),
})

export type loginFormData = InferType<typeof loginSchema>